import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // center AdSlot(s) horizontally within the ad area
    gap: theme.spacing(0.5),
  },
  mediumAd: {
    display: 'none',
    // Below 970px: `banner-ad` shows 300×250; `layout-top-banner` shows 320×50 (see `config/Ads`).
    [theme.breakpoints.down(970)]: {
      display: 'block',
    },
  },
  largeAd: {
    display: 'block',
    // At 970px+: wide banner slot; hidden on narrow viewports where `mediumAd` is used.
    [theme.breakpoints.down(970)]: {
      display: 'none',
    },
  },
  adLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  adLabel: {
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'none',
    },
  },
}));
